import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_TEACHER_BIRTHDAY } from "../Schema/Dashboard";

const useGetTeacherBirthdayForDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_TEACHER_BIRTHDAY, {
    onCompleted: ({ getTeacherBirthdayForDashboard }) => {
      // console.log("getTeacherBirthdayForDashboard::", getTeacherBirthdayForDashboard)
      setTableData(getTeacherBirthdayForDashboard);
      setLoading(false);
    },
    onError: (err) => {
      // console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading };
};

export default useGetTeacherBirthdayForDashboard;
